import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, doc, getDocs } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext';
import { PiBooks } from "react-icons/pi";
import { MdAccountCircle, MdManageAccounts, MdSave, MdSearch } from "react-icons/md";
import { Create_ledger_account } from "../ledger_accounts_root/Create_ledger_account.js";
import logo_default from "../../assets/logo_default.jpg";
import { Randomcode } from "../../components_root/rendom_code.js";
export default function Create_ledger_books_accounts() {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [slug, setSlug] = useState("");

    const [account_type, setAccount_type] = useState("");
    const [accountguid, setaccountguid] = useState(Randomcode(22));
    const [photoURL, setPhotoURL] = useState("https://firebasestorage.googleapis.com/v0/b/aoozpayment.firebasestorage.app/o/icons%2Fledger-icon-design-free-vector.jpg?alt=media&token=de9b8d5c-37a6-42a8-b91f-07d465300190");
    const [accountmobile, setAccountmobile] = useState("");
    const [searchstatus, setSearchstatus] = useState(false);

    const handleCreate = async () => {
        setaccountguid(Randomcode(22));
        if (!accounts_name || !accounts_name.trim()) {
            Toastshow("Please enter oucher name.");
            return;
        }

        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        const data = {
            name: accounts_name.replaceAll("_", " "),
            accountguid,
            mobile,
            logo_url: photoURL,
            usecase: "master",
            slug,
            status: false,
            description: description,
            account_type: account_type.replaceAll(" ", "_").toLowerCase(),
            account_role_type: account_type,
            // Add other necessary fields here
        };
        const result = await Create_ledger_account(data);
        if (result.success) {
            setAccounts_name("");
            setDescription("");
            Toastshow("Voucher saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };



    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const [accounting_groups_raw, setaccounting_groups_raw] = useState([]);

    useEffect(() => {
        const masterQuery = query(
            collection(db, "accounting_groups_list_master")
        );

        const unsubscribeMaster = onSnapshot(masterQuery, (snapshot) => {
            const rawList = snapshot.docs.map((d) => d.data());

            setaccounting_groups_raw(rawList); // 👈 keep raw

        });

        return () => unsubscribeMaster();
    }, []);
    return (
        <div >
            <div className="items-back b-1 rounded p-2">
                <table>
                    <tr>
                        <td><div className="text-h2 bold">Create Ledger Books Account</div></td>
                    </tr>
                    <tr>
                        <td className="text-h3 text-off">Information About Books</td>
                    </tr>


                    <tr>
                        <td>
                            {/* <select
    value={account_type}
    onChange={(e) => setAccount_type(e.target.value)}
    className="text-h2 bold p-2"
>
    <option value="">Select account</option>

    {accounting_groups_raw.reduce((acc, item) => {
        const key = `${item.group}_${item.group_title}`;

        if (!acc[key]) {
            acc[key] = {
                label: `${item.group_title} (${item.group})`,
                items: []
            };
        }

        acc[key].items.push(item);
        return acc;
    }, {}) &&
        Object.values(
            accounting_groups_raw.reduce((acc, item) => {
                const key = `${item.group}_${item.group_title}`;

                if (!acc[key]) {
                    acc[key] = {
                        label: `${item.group_title} (${item.group})`,
                        items: []
                    };
                }

                acc[key].items.push(item);
                return acc;
            }, {})
        ).map((group) => (
            <optgroup key={group.label} label={group.label}>
                {group.items.map((item) => (
                    <option
                        key={item.groupid}
                        value={item.groupid}   // ✅ THIS IS WHAT YOU WANT
                    >
                         <div className="fcap">{item.account_type.replaceAll("_", " ")}</div>
                    </option>
                ))}
            </optgroup>
        ))}
</select> */}

                            <select
                                value={account_type}
                                onChange={(e) => setAccount_type(e.target.value)}
                                className="text-h2 bold p-2">
                                <option value="">Select account</option>
                                <option value="income">Income</option>
                                <option value="expense">Expense</option>
                                <option value="assets">Assets</option>
                                <option value="liabilities">Liabilities</option>
                                <option value="equity">Equity</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td><input type="text" className="p-2" value={accounts_name} onChange={(e) => {
                            setAccounts_name(e.target.value);


                        }} maxLength={30} placeholder="Enter account name" /></td>
                    </tr>
                    <tr>
                        <td><input type="phone" className="p-2" value={mobile} onChange={(e) => {
                            setMobile(e.target.value);


                        }} maxLength={30} placeholder="Enter Mobile number option" /></td>
                    </tr>


                    <tr>
                        <td><div className="text-h2 bold">Description</div></td>
                    </tr>
                    <tr>
                        <td><textarea className="p-2" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                    </tr>
                </table>


                <div className="button-ui green-back p-22 fill text-h2    cursor" onClick={() => handleCreate()}><MdSave className="icon" /> {account_type.replaceAll("_", " ")} Create account</div>



            </div>
        </div>
    );
}
